import { Close, SearchOutlined } from "@mui/icons-material";
import {
  Box,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useEffect, useRef } from "react";

interface SearchParams {
  search: string;
  setSearch: Function;
  selectOptions?: { value: string; name: string }[];
  selectOptionsType?: { value: string; name: string }[];
  setSearchKey?: Function;
  searchKey?: string;
  crDr?: string;
  onSelectCrDrOptions?: Function;
  md?: number;
  hideSearch?: boolean;
  FieldName?: string;
}

export default function SearchPlaces({
  search,
  setSearch,
  selectOptions,
  setSearchKey,
  searchKey,
  selectOptionsType,
  onSelectCrDrOptions,
  crDr,
  md,
  hideSearch,
  FieldName,
}: SearchParams) {
  const ref = useRef<HTMLInputElement>();

  useEffect(() => {
    setTimeout(() => {
      ref?.current?.focus();
    }, 100);
  }, []);

  const handleKeyDown = (event: any) => {
    // Check for Shift + Page Down key combination
    if (event.shiftKey && event.key === "PageDown" && selectOptions?.length) {
      // Change the selected value as needed
      // For example, you can set it to the next value in your options list
      // In this example, assuming you have an array of options: ['Option 1', 'Option 2', ...]
      // You should handle the boundary case when the current selected value is the last one
      const currentIndex = selectOptions?.findIndex(
        (obj: { value: string; name: string }) => obj?.value === searchKey,
      );
      const nextIndex =
        currentIndex < selectOptions.length - 1
          ? currentIndex + 1
          : currentIndex;
      const nextValue = selectOptions[nextIndex];

      // Update the state to reflect the new selected value
      if (nextValue) {
        setSearchKey && setSearchKey(nextValue.value);
      }
    }
  };

  return (
    <Box sx={{ width: "100%", mb: 2 }}>
      <Grid
        container
        spacing={1.5}
        justifyContent="flex-end"
        alignItems="center"
      >
        <Grid item xs={12} sm={12} md={md || (selectOptionsType?.length && selectOptions?.length ? 10 : 8)} lg={md || (selectOptionsType?.length && selectOptions?.length ? 8 : 6)}>
          <Grid container spacing={1.5}>
            {selectOptionsType?.length ? (
              <Grid item xs={12} sm={selectOptions?.length ? 4 : 6}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel>Select CR DR</InputLabel>
                  <Select
                    name="Column"
                    value={crDr || ""}
                    onChange={(e) => {
                      onSelectCrDrOptions &&
                        onSelectCrDrOptions(e.target.value);
                    }}
                    label="Select CR DR"
                  >
                    <MenuItem value="">All (CR/DR)</MenuItem>
                    {selectOptionsType?.map((option) => (
                      <MenuItem key={option.name} value={option.value}>
                        {option.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            ) : null}

            {!hideSearch ? (
              <>
                {selectOptions?.length ? (
                  <Grid item xs={12} sm={selectOptionsType?.length ? 4 : 5}>
                    <FormControl fullWidth variant="outlined" size="small">
                      <InputLabel>Search By</InputLabel>
                      <Select
                        name="Column"
                        size="small"
                        aria-label="Search By"
                        fullWidth
                        label="Search By"
                        variant="outlined"
                        value={searchKey || ""}
                        onKeyDown={handleKeyDown}
                        onChange={(e) => {
                          setSearchKey && setSearchKey(e.target.value);
                        }}
                      >
                        {selectOptions?.map((option) => (
                          <MenuItem key={option.name} value={option.value}>
                            {option.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                ) : null}

                <Grid item xs={12} sm={selectOptionsType?.length ? (selectOptions?.length ? 4 : 6) : (selectOptions?.length ? 7 : 12)}>
                  <FormControl fullWidth variant="outlined" size="small">
                    <TextField
                      id="input-with-icon-textfield"
                      label={FieldName || "Search..."}
                      variant="outlined"
                      size="small"
                      name="searchName"
                      value={search}
                      inputRef={ref}
                      onChange={(e) => setSearch(e.target.value)}
                      placeholder={FieldName || "Type to search..."}
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchOutlined fontSize="small" />
                          </InputAdornment>
                        ),
                        endAdornment: search ? (
                          <InputAdornment position="end">
                            <IconButton
                              size="small"
                              onClick={() => setSearch("")}
                              edge="end"
                            >
                              <Close fontSize="small" />
                            </IconButton>
                          </InputAdornment>
                        ) : null,
                      }}
                    />
                  </FormControl>
                </Grid>
              </>
            ) : null}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
